module.exports = globalThis.__webpack_lazy_fm__.systemjs('@onvio/staff-setup');